import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.policyHub || initialState;

export const selectPolicyHub = createSelector(
  [selectDomain],
  policyHubState => policyHubState,
);
